// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PLR3B","footer_hideOnTouch":"Footer_footer_hideOnTouch__YhT2i","footer_hideOnDesktop":"Footer_footer_hideOnDesktop__Z_RxM","divider":"Footer_divider__DHbf4"};